/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreatePhotonBeamQualitiesDto } from './CreatePhotonBeamQualitiesDto';
import {
    CreatePhotonBeamQualitiesDtoFromJSON,
    CreatePhotonBeamQualitiesDtoFromJSONTyped,
    CreatePhotonBeamQualitiesDtoToJSON,
} from './CreatePhotonBeamQualitiesDto';
import type { CreateElectronBeamQualitiesDto } from './CreateElectronBeamQualitiesDto';
import {
    CreateElectronBeamQualitiesDtoFromJSON,
    CreateElectronBeamQualitiesDtoFromJSONTyped,
    CreateElectronBeamQualitiesDtoToJSON,
} from './CreateElectronBeamQualitiesDto';
import type { CreateBeamQualityDto } from './CreateBeamQualityDto';
import {
    CreateBeamQualityDtoFromJSON,
    CreateBeamQualityDtoFromJSONTyped,
    CreateBeamQualityDtoToJSON,
} from './CreateBeamQualityDto';

/**
 * 
 * @export
 * @interface ValidateBeamQualityDto
 */
export interface ValidateBeamQualityDto {
    /**
     * 
     * @type {CreateBeamQualityDto}
     * @memberof ValidateBeamQualityDto
     */
    beamQualityToValidate: CreateBeamQualityDto;
    /**
     * 
     * @type {CreateElectronBeamQualitiesDto}
     * @memberof ValidateBeamQualityDto
     */
    beamQualitiesElectron?: CreateElectronBeamQualitiesDto;
    /**
     * 
     * @type {CreatePhotonBeamQualitiesDto}
     * @memberof ValidateBeamQualityDto
     */
    beamQualitiesPhoton?: CreatePhotonBeamQualitiesDto;
    /**
     * 
     * @type {string}
     * @memberof ValidateBeamQualityDto
     */
    $type?: ValidateBeamQualityDtoTypeEnum;
}


/**
 * @export
 */
export const ValidateBeamQualityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationValidateBeamQualityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ValidateBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ValidateBeamQualityDtoTypeEnum = typeof ValidateBeamQualityDtoTypeEnum[keyof typeof ValidateBeamQualityDtoTypeEnum];



/**
 * Check if a given object implements the ValidateBeamQualityDto interface.
 */
export function instanceOfValidateBeamQualityDto(value?: unknown): value is ValidateBeamQualityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ValidateBeamQualityDtoTypeEnum)[0];
}

export function ValidateBeamQualityDtoFromJSON(json: any): ValidateBeamQualityDto {
    return ValidateBeamQualityDtoFromJSONTyped(json, false);
}

export function ValidateBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateBeamQualityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'beamQualityToValidate': CreateBeamQualityDtoFromJSON(json['beamQualityToValidate']),
        'beamQualitiesElectron': json['beamQualitiesElectron'] == null ? undefined : CreateElectronBeamQualitiesDtoFromJSON(json['beamQualitiesElectron']),
        'beamQualitiesPhoton': json['beamQualitiesPhoton'] == null ? undefined : CreatePhotonBeamQualitiesDtoFromJSON(json['beamQualitiesPhoton']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ValidateBeamQualityDtoToJSON(value?: ValidateBeamQualityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'beamQualityToValidate': CreateBeamQualityDtoToJSON(value['beamQualityToValidate']),
        'beamQualitiesElectron': CreateElectronBeamQualitiesDtoToJSON(value['beamQualitiesElectron']),
        'beamQualitiesPhoton': CreatePhotonBeamQualitiesDtoToJSON(value['beamQualitiesPhoton']),
        '$type': value['$type'],
    });
}

